export const SEO_DESCRIPTIONS = {
  REVIEWS: '앨범을 평가하고 리뷰를 남겨보세요.',
  NEWS: '음악 관련 최신 뉴스',
  NOTICE: '포스트팝 공지사항 입니다.',
  LISTS: '나만의 플레이리스트를 만들고 공유해보세요.',
};
